module.exports = __webpack_public_path__ + "static/media/add-large.d44ba333.svg";